import { gql } from '@moonpig/web-core-graphql'

export const GetPreviousPageBreadcrumbTitles = gql`
  query GetPreviousPageBreadcrumbTitles($path: String!) {
    page(path: $path) {
      ... on Page {
        title
        path
        modules {
          __typename
          ... on ModuleBreadcrumbs {
            breadcrumbs {
              title
            }
          }
        }
      }
    }
  }
`
